module.exports = __webpack_public_path__ + "assets/svg/Icons/16/task-gray-fed4a5.svg";